import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import { find, findIndex, unionBy, differenceBy, intersectionBy, isEqual, isUndefined } from 'lodash-es';
import { IconClose } from '../../../icons';
import { safeInvoke, isFunction, marginClass, ControlSizeType, ControlDensityType, ControlAppearanceType, isDefined } from '../../../library';
import { Menu } from '../../menu';
import { Button, Buttons } from '../../button';
export var ObjectList = function (_React$Component) {
  _inherits(ObjectList, _React$Component);
  var _super = _createSuper(ObjectList);
  function ObjectList() {
    var _this;
    _classCallCheck(this, ObjectList);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      selectedItems: [],
      pagination: {
        curPage: 1
      },
      lastSelected: {
        item: null,
        action: null
      }
    });
    _defineProperty(_assertThisInitialized(_this), "isObjectDisabled", function (item, objectDisabled) {
      if (objectDisabled === undefined || objectDisabled == null || item == null) {
        return false;
      } else if (isFunction(objectDisabled)) {
        return objectDisabled(item);
      }
      return !!item[objectDisabled];
    });
    _defineProperty(_assertThisInitialized(_this), "runAction", function (fn, items) {
      safeInvoke(fn, items);
      _this.deselectAll();
    });
    _defineProperty(_assertThisInitialized(_this), "getApi", function () {
      return {
        deselectAll: _this.deselectAll,
        handleSelect: _this.handleSelect,
        isAllSelected: _this.isAllSelected,
        isSelected: _this.isSelected,
        renderActionMenu: _this.renderActionMenu,
        setPage: _this.setPage,
        select: _this.select,
        selectAll: _this.selectAll,
        selectAllToggle: _this.selectAllToggle,
        toggleSelect: _this.toggleSelect
      };
    });
    _defineProperty(_assertThisInitialized(_this), "getSelectedItems", function () {
      return _this.state.selectedItems;
    });
    _defineProperty(_assertThisInitialized(_this), "handleSelect", function (e, item) {
      var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (_this.props.isDisabled || !_this.props.isSelectable || _this.isObjectDisabled(item)) return;
      if (e.shiftKey) {
        var _document$getSelectio;
        (_document$getSelectio = document.getSelection()) === null || _document$getSelectio === void 0 || _document$getSelectio.removeAllRanges();
        e.preventDefault();
        if (_this.state.lastSelected.action === 'select') {
          _this.select(item, true);
        } else if (_this.state.lastSelected.action === 'deselect') {
          _this.deselect(item, true);
        } else {
          _this.select(item);
        }
      } else if (force || e.ctrlKey || e.metaKey) {
        e.preventDefault();
        _this.toggleSelect(item);
      } else {
        _this.select(item, false, true);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "toggleSelect", function (item) {
      var key = _this.props.idProp;
      var index = findIndex(_this.state.selectedItems, [key, item[key]]);
      if (index > -1) {
        _this.deselect(item);
      } else {
        _this.select(item);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getSelectRange", function (item) {
      var items = [item];
      var key = _this.props.idProp;
      var lastIndex = isDefined(_this.state.lastSelected.item) ? findIndex(_this.props.items, [key, _this.state.lastSelected.item[key]]) : null;
      var index = findIndex(_this.props.items, [key, item[key]]);
      if (lastIndex !== null && index > -1) {
        if (lastIndex > index) {
          items = _this.props.items.slice(index, lastIndex + 1);
        } else {
          items = _this.props.items.slice(lastIndex, index + 1);
        }
      }
      return items;
    });
    _defineProperty(_assertThisInitialized(_this), "select", function (item) {
      var selectTo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var onlyNew = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var maxSelect = _this.props.maxSelect;
      if (maxSelect === 0) return;
      var items = selectTo ? _this.getSelectRange(item) : Array.isArray(item) ? item : [item];
      var returnItems = onlyNew ? items : unionBy(_this.state.selectedItems, items, _this.props.idProp);
      returnItems = returnItems.filter(function (item) {
        return !_this.isObjectDisabled(item);
      });
      if (maxSelect > 0 && returnItems.length >= maxSelect) {
        returnItems = returnItems.slice(-maxSelect);
      }
      _this.setState({
        selectedItems: returnItems,
        lastSelected: {
          item: item,
          action: 'select'
        }
      });
      safeInvoke(_this.props.onSelectChange, returnItems);
    });
    _defineProperty(_assertThisInitialized(_this), "deselect", function (item) {
      var selectTo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var items = selectTo ? _this.getSelectRange(item) : Array.isArray(item) ? item : [item];
      var filteredItems = differenceBy(_this.state.selectedItems, items, _this.props.idProp);
      safeInvoke(_this.props.onSelectChange, filteredItems);
      _this.setState({
        selectedItems: filteredItems,
        lastSelected: {
          item: item,
          action: 'deselect'
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "selectAll", function () {
      var curPage = _this.state.pagination.curPage;
      var _this$props = _this.props,
        itemsPerPage = _this$props.itemsPerPage,
        maxSelect = _this$props.maxSelect;
      var start = (curPage - 1) * itemsPerPage;
      var end = itemsPerPage > -1 ? start + itemsPerPage : undefined;
      var items = _this.props.items.slice(start, end).filter(function (item) {
        return !_this.isObjectDisabled(item);
      });
      if (maxSelect > -1) {
        items = items.slice(0, maxSelect);
      }
      console.log({
        start: start,
        end: end,
        itemsPerPage: itemsPerPage,
        maxSelect: maxSelect,
        curPage: curPage
      });
      safeInvoke(_this.props.onSelectChange, items);
      _this.setState({
        selectedItems: items
      });
    });
    _defineProperty(_assertThisInitialized(_this), "deselectAll", function () {
      safeInvoke(_this.props.onSelectChange, []);
      _this.setState({
        selectedItems: [],
        lastSelected: {
          action: null,
          item: null
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "selectAllToggle", function () {
      if (_this.props.isDisabled) return;
      if (_this.isAllSelected()) {
        _this.deselectAll();
      } else {
        _this.selectAll();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "isSelected", function (item) {
      return findIndex(_this.state.selectedItems, [_this.props.idProp, item[_this.props.idProp]]) > -1;
    });
    _defineProperty(_assertThisInitialized(_this), "isAllSelected", function () {
      var selectedCount = _this.state.selectedItems.length;
      return _this.props.maxSelect > -1 && selectedCount >= _this.props.maxSelect || _this.props.itemsPerPage > -1 && selectedCount >= _this.props.itemsPerPage || (_this.state.pagination.curPage - 1) * _this.props.itemsPerPage + selectedCount >= _this.props.items.length;
    });
    _defineProperty(_assertThisInitialized(_this), "setPage", function (page) {
      _this.setState(function (_ref) {
        var pagination = _ref.pagination;
        pagination.curPage = page;
        return {
          pagination: pagination
        };
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderChildren", function (items, actions) {
      return _this.props.children({
        items: items,
        actions: actions,
        api: _this.getApi(),
        selectedItems: _this.state.selectedItems
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderActionMenu", function (item) {
      var actions = _this.props.actions;
      var actionList = actions === null || actions === void 0 ? void 0 : actions.filter(function (action) {
        return action["for"] === 'single' || action["for"] === 'all';
      });
      if (isUndefined(actionList) || actionList.length === 0) return null;
      var runAction = function runAction(e) {
        var id = e.currentTarget.id;
        var action = find(actions, {
          id: id
        });
        safeInvoke(action === null || action === void 0 ? void 0 : action.fn, [item]);
      };
      return React.createElement(Menu, {
        className: "object-action-menu",
        isVertical: true,
        appearance: "pill"
      }, actionList.map(function (action) {
        var _action$isDisabled;
        return React.createElement(Menu.Item, {
          key: action.id,
          id: action.id,
          onClick: runAction,
          label: action.label,
          intent: action.intent,
          icon: action.icon,
          isDisabled: (_action$isDisabled = action.isDisabled) === null || _action$isDisabled === void 0 ? void 0 : _action$isDisabled.call(action, item)
        });
      }));
    });
    return _this;
  }
  _createClass(ObjectList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      safeInvoke(this.props.getApi, this.getApi());
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.isSelectable !== this.props.isSelectable && this.props.isSelectable === false) {
        this.deselectAll();
      }
      if (!isEqual(prevProps.items, this.props.items)) {
        var newSelectedItems = intersectionBy(this.state.selectedItems, this.props.items, this.props.idProp);
        this.setState({
          selectedItems: newSelectedItems
        });
        safeInvoke(this.props.onSelectChange, newSelectedItems);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$actions,
        _this2 = this;
      var actionBarActions = (_this$props$actions = this.props.actions) === null || _this$props$actions === void 0 ? void 0 : _this$props$actions.filter(function (action) {
        if (_this2.state.selectedItems.length === 0) return false;
        if (action["for"] === 'all') return true;
        return _this2.state.selectedItems.length > 1 ? action["for"] === 'multiple' : action["for"] === 'single';
      }).map(function (action) {
        return _objectSpread(_objectSpread({}, action), {}, {
          fn: function fn() {
            return _this2.runAction(action.fn, _this2.state.selectedItems);
          }
        });
      });
      return this.renderChildren(this.props.items, actionBarActions !== null && actionBarActions !== void 0 ? actionBarActions : []);
    }
  }]);
  return ObjectList;
}(React.Component);
_defineProperty(ObjectList, "displayName", 'ObjectList');
_defineProperty(ObjectList, "defaultProps", {
  actions: [],
  isDisabled: false,
  isSelectable: false,
  items: [],
  idProp: 'id',
  maxSelect: -1,
  itemsPerPage: -1
});
export var ActionBar = function ActionBar(props) {
  var actions = props.actions,
    selected = props.selected;
  return React.createElement("div", {
    className: "action-bar"
  }, React.createElement(Button, {
    className: marginClass([null, 2, null, null]),
    size: ControlSizeType.SMALL,
    density: ControlDensityType.COMPACT,
    appearance: ControlAppearanceType.MINIMAL,
    title: "Deselect",
    onClick: props.deselectAll,
    label: React.createElement(IconClose, null)
  }), React.createElement("span", {
    className: "m--x-1"
  }, React.createElement("strong", null, selected.length), " ", React.createElement("small", null, "selected")), React.createElement(Buttons, {
    className: "action-bar__actions",
    appearance: "fill",
    isInline: true
  }, actions.map(function (action) {
    var disabled = selected.length === 0 ? true : !!action.isDisabled && selected.some(action.isDisabled);
    return React.createElement(Button, {
      key: action.id,
      isDisabled: disabled,
      intent: action.intent ? action.intent : 'none',
      onClick: function onClick() {
        return action.fn();
      },
      density: "compact",
      before: action.icon,
      label: action.label
    });
  })));
};
ActionBar.defaultProps = {
  actions: [],
  selected: []
};